import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { theme } from "../../foundations/theme.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import { forwardRef } from "react";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import { styled } from "@mui/material";
import { CloudUploadOutlined as l } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/cloud-upload-outlined.es.es.js";
import { CheckCircleSolid as e } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/check-circle-solid.es.es.js";
import { TriangleExclamationSolid as C } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/triangle-exclamation-solid.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { Accordion } from "../accordion/accordion.es.js";
import { MuiClassCollection } from "../../foundations/mui-class-collection.es.js";
import { Spacing } from "../../foundations/spacing.es.js";
var UploaderAccordionVariant = /* @__PURE__ */ ((UploaderAccordionVariant2) => {
  UploaderAccordionVariant2["RequestUpload"] = "request-upload";
  UploaderAccordionVariant2["UploadSuccess"] = "upload-success";
  UploaderAccordionVariant2["Success"] = "success";
  UploaderAccordionVariant2["Error"] = "error";
  return UploaderAccordionVariant2;
})(UploaderAccordionVariant || {});
const iconMapping = {
  [
    "request-upload"
    /* RequestUpload */
  ]: /* @__PURE__ */ jsx(l, { className: "uploader-icon" }),
  [
    "upload-success"
    /* UploadSuccess */
  ]: /* @__PURE__ */ jsx(l, { className: "uploader-icon" }),
  [
    "success"
    /* Success */
  ]: /* @__PURE__ */ jsx(e, { className: "uploader-icon" }),
  [
    "error"
    /* Error */
  ]: /* @__PURE__ */ jsx(C, { className: "uploader-icon" })
};
const UploaderAccordionElement = styled(Accordion)({
  [`&.${"request-upload"}`]: {
    borderLeft: `${Spacing["500"]} solid ${theme.palette.primary.main}`,
    borderColor: theme.palette.primary.main,
    "& .uploader-icon": {
      color: theme.palette.primary.main
    }
  },
  [`&.${"upload-success"}`]: {
    borderLeft: `${Spacing["500"]} solid ${theme.palette.secondary.main}`,
    borderColor: theme.palette.secondary.main,
    "& .uploader-icon": {
      color: theme.palette.secondary.main
    }
  },
  [`&.${"success"}`]: {
    borderLeft: `${Spacing["500"]} solid ${theme.palette.success.main}`,
    borderColor: theme.palette.success.main,
    "& .uploader-icon": {
      color: theme.palette.success.main
    }
  },
  [`&.${"error"}`]: {
    borderLeft: `${Spacing["500"]} solid ${theme.palette.error.main}`,
    borderColor: theme.palette.error.main,
    "& .uploader-icon": {
      color: theme.palette.error.main
    }
  },
  "&.uploader-disabled": {
    borderLeft: `${Spacing["500"]} solid ${theme.palette.primary.light}`,
    borderColor: theme.palette.primary.light,
    color: theme.palette.text.disabled,
    "& .uploader-icon": {
      color: theme.palette.action.disabled
    },
    "> *": {
      cursor: "not-allowed !important"
    }
  },
  [`&.${MuiClassCollection.disabled}`]: {
    backgroundColor: "transparent",
    cursor: "not-allowed !important"
  }
});
const UploaderAccordion = forwardRef(function UploaderAccordion2({
  children,
  uploadVariant,
  className,
  endAction,
  endChip,
  isMobile,
  disabled = false,
  ...rest
}, ref) {
  const leftIcon = iconMapping[uploadVariant];
  const classNameOverride = `${className} ${uploadVariant} ${disabled ? "uploader-disabled" : ""}`;
  return /* @__PURE__ */ jsx(UploaderAccordionElement, { ref, disabled, startIcon: leftIcon, className: classNameOverride, isMobile, endChip, endAction, ...rest, children });
});
export {
  UploaderAccordion,
  UploaderAccordionVariant
};
//# sourceMappingURL=uploader-accordion.es.js.map
